import Password from './password/Password.vue';
import Profile from './profile/Profile.vue';

export default {
  components: {
    password: Password,
    profile: Profile,
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/account/Account.js